import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard
// import Dashboard from "../Pages/Dashboard";

// Import Authentication pages
import Login from "../Pages/Authentication/Login";
import ForgetPasswordPage from "../Pages/Authentication/ForgetPassword";
import Logout from "../Pages/Authentication/Logout";
import Register from "../Pages/Authentication/Register";
import UserProfile from "../Pages/Authentication/user-profile";
import SchoolPage from "../Pages/School";
import CompanyPage from "../Pages/company";
import JobPage from "../Pages/job";
import DegreePage from "../Pages/degree";
import TnCPage from "../Pages/TnC";
import ModalKeyValuePage from "../Pages/ModalKeyValue";
import PrivacyPolicy from "../Pages/privacyPolicy";
import CookiePolicy from "../Pages/cookiePolicy";
import TempTable from "../Pages/tempTable";
import UserBadgePage from "../Pages/userBadge";
import BadgePage from "../Pages/badge";
import LookingForTable from "../Pages/lookingFor";
import LookingForAnalytics from "../Pages/Analytics/lookingForAnalytics.js";
import GenderAnalytics from "../Pages/Analytics/GenderAnalytics.js";
import FOSPage from "../Pages/fos";
import SportPage from "../Pages/sports";
import InterestPage from "../Pages/interest/interest";
import InterestGroupPage from "../Pages/interest/group-interest";
import SkillsPage from "../Pages/skill/skill";
import GroupSkillPage from "../Pages/skill/group-skills";
import SkillGroupAssociation from "../Pages/skill/skill-group-association";
import InterestGroupAssociation from "../Pages/interest/interest-group-association";
import InterestGroupAnalytics from "../Pages/Analytics/InterestAnalytics.js";
import HotspotModerationPage from "../Pages/hotspotModeration";
import ReportedHotspotPage from "../Pages/reportedHotspot";
import UserModerationPage from "../Pages/userModeration";
import ReportedUsersPage from "../Pages/reportedUsers";
import ReportedBroadcastPage from "../Pages/reportedBroadcast";
import PendingBroadcastsPage from "../Pages/pendingBroadcasts";
import UserBannerPage from "../Pages/userBanner";
import TokenStatusPage from "../Pages/tokenStatus";
import SupportPage from "../Pages/support";
import BusinessVerificationPage from "../Pages/businessVerification";
import UserPhoneOtpPage from "../Pages/userPhoneOtp";

const authProtectedRoutes = [
  //dashboard
  // { path: "/dashboard", component: <Dashboard /> },
  { path: "/school", component: <SchoolPage /> },
  { path: "/company", component: <CompanyPage /> },
  { path: "/job", component: <JobPage /> },
  { path: "/degree", component: <DegreePage /> },
  { path: "/TnC", component: <TnCPage /> },
  { path: "/modal-key-value", component: <ModalKeyValuePage /> },
  { path: "/privacyPolicy", component: <PrivacyPolicy /> },
  { path: "/cookiePolicy", component: <CookiePolicy /> },
  { path: "/tempTable", component: <TempTable /> },
  { path: "/userBadge", component: <UserBadgePage /> },
  { path: "/badge", component: <BadgePage /> },
  { path: "/lookingFor", component: <LookingForTable /> },
  { path: "/lookingForAnalytics", component: <LookingForAnalytics /> },
  { path: "/InterestGroupAnalytics", component: <InterestGroupAnalytics /> },
  { path: "/hotspotModeration", component: <HotspotModerationPage /> },
  { path: "/reportedHotspot", component: <ReportedHotspotPage /> },
  { path: "/userModeration", component: <UserModerationPage /> },
  { path: "/reportedUsers", component: <ReportedUsersPage /> },
  { path: "/reportedBroadcast", component: <ReportedBroadcastPage /> },
  { path: "/pendingBroadcasts", component: <PendingBroadcastsPage /> },
  { path: "/businessVerification", component: <BusinessVerificationPage /> },
  { path: "/userPhoneOtp", component: <UserPhoneOtpPage /> },
  { path: "/userBanner", component: <UserBannerPage /> },
  { path: "/tokenStatus", component: <TokenStatusPage /> },
  { path: "/support", component: <SupportPage /> },
  
  { path: "/GenderAnalytics", component: <GenderAnalytics /> },
  { path: "/fos", component: <FOSPage /> },
  { path: "/sports", component: <SportPage /> },
  { path: "/interest", component: <InterestPage /> },
  { path: "/group-interest", component: <InterestGroupPage /> },
  { path: "/skills", component: <SkillsPage /> },
  { path: "/group-skills", component: <GroupSkillPage /> },
  { path: "/skills-group-association", component: <SkillGroupAssociation /> },
  {
    path: "/interest-group-association",
    component: <InterestGroupAssociation />,
  },

  // Profile
  { path: "/userprofile", component: <UserProfile /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/school" />,
  },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },
];

export { authProtectedRoutes, publicRoutes };
